import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription, throwError } from 'rxjs';
import { catchError, finalize, take, tap } from 'rxjs/operators';
import { AppError } from 'src/app/core/errors/http-error/app-error';
import { MenuEventService } from 'src/app/layers/actions/map-actions/menu-event.service';
import { LayerService } from 'src/app/layers/service/layer.service';
import { ProjectQuery } from 'src/app/projects/state/project.query';
import { ResultDownloadListComponent } from 'src/app/result/result-download/result-download-list/result-download-list.component';
import { ResultMapLayerService } from 'src/app/result/result-map/service/result-map-layer.service';
import { ResultTreeComponent } from 'src/app/result/result-tree/result-tree.component';
import { MapDrawService } from 'src/app/shared/components/map/map-draw.service';
import { MapService } from 'src/app/shared/components/map/map.service';
import { WindowService } from 'src/app/shared/components/window/window.service';
import { Simulation } from '../state/simulation.model';
import { SimulationQuery } from '../state/simulation.query';
import { SimulationService } from '../state/simulation.service';

@Component({
  selector: 'app-simulation-result',
  templateUrl: './simulation-result.component.html',
  styleUrls: ['./simulation-result.component.scss']
})
export class SimulationResultComponent implements OnInit, OnDestroy {

  simulation$: Observable<Simulation>;
  isLoading: boolean;
  error: AppError;
  resultMode = false;

  private styleSubs: Subscription;

  constructor(
    private windowService: WindowService,
    private layerService: LayerService,
    private projectQuery: ProjectQuery,
    private simulationQuery: SimulationQuery,
    private resultMapLayerService: ResultMapLayerService,
    private simulationService: SimulationService,
    private menuEventService: MenuEventService,
    private drawService: MapDrawService,
    private mapService: MapService
  ) { }

  ngOnInit(): void {
    this.menuEventService.active = false;
    this.drawService.disable();
    this.load();
  }

  ngOnDestroy(): void {
    this.menuEventService.active = true;
    this.simulationService.setResultMode(false);
    this.drawService.clear();
    this.resultMapLayerService.clear();
    this.layerService.show();

    if (this.styleSubs) {
      this.styleSubs.unsubscribe();
    }
  }

  showResultMap() {
    this.drawService.clear();
    this.layerService.hide();

    this.resultMode = true;
    this.simulationService.setResultMode(this.resultMode);
    this.loadResultMap();

    this.styleSubs = this.mapService.styleChanged$.subscribe(() => {
      this.loadResultMap();
    });
  }

  download() {
    const titleConfig = $localize`RESULT DOWNLOAD`;
    this.windowService.open({
      title: titleConfig,
      componentType: ResultDownloadListComponent,
      config: { id: 'RESULT_DOWNLOAD' }
    });
  }

  openResultTree() {
    const titleConfig = $localize`RESULT TREE`;
    this.windowService.open({
      title: titleConfig,
      componentType: ResultTreeComponent,
      help: 'NETWORK_RESULT',
      config: { id: 'RESULT_TREE' }
    });
  }

  private load() {
    this.isLoading = true;

    const simulatioId = this.simulationQuery.getActiveId();

    this.simulation$ = this.simulationService.getById(simulatioId)
      .pipe(
        tap(s => {
          s.areas_definition.forEach(a => this.drawService.addArea(a));
        }),
        catchError((error) => {
          this.error = error;
          return throwError(error);
        }),
        finalize(() => this.isLoading = false)
      );
  }

  private loadResultMap() {
    this.isLoading = true;

    const projectId = this.projectQuery.getActiveId();
    const simulatioId = this.simulationQuery.getActiveId();
    this.resultMapLayerService.load(projectId, simulatioId)
      .pipe(take(1))
      .subscribe(() => this.isLoading = false);
  }

}
